import { useNavigate, useParams, useLocation } from "react-router-dom";
//import { useAuth } from "../../context/AuthContext";
export const WithRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    // const { user } = useAuth();

    return (
      <Component
        navigate={navigate}
        location={location}
        params={params}

        {...props}
      />
    );
  };

  return Wrapper;
};
